'use strict';

define('TrackSelectorWindowCtrl',[],
    function () {
            function TrackSelectorWindowCtrl($scope, $rootScope, $routeParams, LocationUnreloadFac, GTMFac) {
                $scope.data = {
                    loading: true,
                    tracks: [],
                    error: null,
                    trackAbbr: $routeParams.trackAbbr,
                    raceNumber: $routeParams.raceNumber,
                    racesLoading: true
                };

                function _processRaceList(tracks) {
                    $scope.data.tracks = tracks;

                    var trackSelected = _.find($scope.data.tracks, function (track) {
                        return track.trackAbbr === $scope.data.trackAbbr;
                    });

                    $scope.data.trackSelected = {
                        name: trackSelected.name,
                        trackAbbr: trackSelected.trackAbbr,
                        perfAbbr: trackSelected.perfAbbr
                    };

                    $scope.data.races = trackSelected.races;
                    $scope.data.currentRace = _.find($scope.data.races, function (o) {
                        return o.raceNumber === parseInt($scope.data.raceNumber, 10);
                    });

                    if ($scope.data.trackSelected) {
                        $scope.data.oldTrackSelected = $scope.data.trackSelected;
                        $scope.data.racesLoading = false;
                        $scope.data.loading = false;
                    }
                }

                function _onTrackChangedForNewTrackSelector(track){
                    $scope.data.loading = true;
                    $scope.data.trackSelected = track;
                    $scope.data.trackSelected.name = track.trackName;
                    LocationUnreloadFac.pathChange.apply(this, _buildLocationPathParams(track.trackAbbr, track.perfAbbr, track.raceNumber));
                }

                function _raceChanged() {
                    var raceNumber = $scope.data.currentRace.raceNumber;
                    var trackAbbr = $scope.data.trackSelected.trackAbbr;
                    var perfAbbr = $scope.data.trackSelected.perfAbbr;
                    LocationUnreloadFac.pathChange.apply(this, _buildLocationPathParams(trackAbbr, perfAbbr, raceNumber));

                    if($rootScope.isBetslipApp) {
                        var p = {};
                        p.eventLabel = 'BetTicket-RaceDropDown';
                        p.gaEventCategory = 'Site Click';
                        p.gaEventAction = 'Bet Ticket Page Click';
                        p.gaEventLabel = 'Races Changes';
                        p.screenName = 'Bet Ticket Page';
                        p.sectionName = 'Bet Ticket | Bet Ticket Page';
                        p.raceNumber = "R" + $scope.data.currentRace.raceNumber;
                        p.trackName = $scope.data.currentRace.trackName;
                        GTMFac.GTMEvent().send($rootScope, 'siteClick', p);
                    }
                }

                function _buildNextTrackPath(trackAbbr, perfAbbr, raceNumber){
                    return "/betslip/_trackAbbr_/_perfAbbr_/_raceNumber_"
                        .replace("_trackAbbr_", trackAbbr)
                        .replace("_perfAbbr_", perfAbbr)
                        .replace("_raceNumber_", raceNumber);
                }

                var unbind = [];

                unbind.push($rootScope.$on('trackListReady', function (event, data) {
                    _processRaceList(data);
                }));

                unbind.push($rootScope.$on('race:Changed', function () {
                    $scope.data.loading = true;
                    if ($routeParams.trackAbbr !== $scope.data.trackAbbr) {
                        $scope.data.trackAbbr = $routeParams.trackAbbr;
                        $scope.data.raceNumber = $routeParams.raceNumber;
                        _processRaceList($scope.data.tracks);
                        $scope.data.loading = false;
                        $scope.$emit("BetSlip::RaceChanged", true);
                    } else {
                        $scope.data.raceNumber = $routeParams.raceNumber;
                        $scope.data.loading = false;
                        $scope.$emit("BetSlip::RaceChanged", false);
                    }
                }));

                unbind.push($rootScope.$on('raceListReady', function (event, races, trackAb){
                    $scope.data.tracks.forEach(function (track) {
                        if(track.trackAbbr == trackAb) {
                            track.races = races;
                        }
                    });
                }));

                function _buildLocationPathParams(trackAbbr, perfAbbr, raceNumber) {
                    var args = [];
                    args.push(_buildNextTrackPath(trackAbbr, perfAbbr, raceNumber));
                    args.push(false);
                    args.push({trackAbbr: trackAbbr, perfAbbr: perfAbbr, raceNumber: raceNumber});
                    args.push('race:Changed');
                    return args;
                }

                $scope.events = {
                    raceChanged: _raceChanged,
                    onTrackChangedForNewTrackSelector: _onTrackChangedForNewTrackSelector
                };
            }

            TrackSelectorWindowCtrl.$inject = [
                '$scope',
                '$rootScope',
                '$routeParams',
                'LocationUnreloadFac',
                'GTMFac'
            ];

            return TrackSelectorWindowCtrl;
        }
);

